import * as React from 'react';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuggestItemLeftIcon = props => {
  return /*#__PURE__*/_jsx("div", {
    className: styles['icon'],
    children: props.children
  });
};